import get from 'lodash-es/get';
import isString from 'lodash-es/isString';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link as Link$1 } from 'wouter';

var propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  value: PropTypes.string,
  label: PropTypes.string,
  labelPath: PropTypes.string,
  external: PropTypes.bool,
  target: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};
var defaultProps = {
  item: null,
  value: null,
  label: null,
  labelPath: null,
  external: false,
  target: null,
  placeholder: null
};
var Link = function Link(_ref) {
  var item = _ref.item,
    label = _ref.label,
    labelPath = _ref.labelPath,
    value = _ref.value,
    external = _ref.external,
    target = _ref.target,
    placeholder = _ref.placeholder;
  var itemLabel = get(item, labelPath);
  var finalValue = itemLabel || label || placeholder || /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "e0xuLo",
    defaultMessage: [{
      "type": 0,
      "value": "Link"
    }]
  });
  var isExternal = value !== null && isString(value) ? value.indexOf('http') === 0 : false;
  return external || isExternal ? /*#__PURE__*/React.createElement("a", {
    href: value,
    target: target || '_blank',
    rel: "noopener noreferrer"
  }, finalValue) : /*#__PURE__*/React.createElement(Link$1, {
    href: value
  }, finalValue);
};
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;

export { Link as default };
